import { httpClient } from '../network/httpclient/HttpClientFactory';
import authHeader from './Header';
export default {
    sendLog: log2Object => httpClient.post('/apperrlog', log2Object, { headers: authHeader() }),

    accessLog: param => httpClient.post('/appLastAccess', param, { headers: authHeader() })
};
